import * as R from 'ramda'

import {
  FILTER_TYPE_GT,
  FILTER_TYPE_LT,
} from '@infotech/filters'

const parseValue = R.mapObjIndexed((date) => Number.isNaN(+date)
  ? date
  : new Date(+date))

const valueToFilter = (value) => {
  if (value.datePeriod) {
    return { [FILTER_TYPE_GT]: value.datePeriod }
  }

  const query = {
    [FILTER_TYPE_GT]: value.Gt,
    [FILTER_TYPE_LT]: value.Lt,
  }

  // если в Gt и Lt даты, берем таймстамп
  if (value.Gt && value.Gt.toISOString) {
    query[FILTER_TYPE_GT] = value.Gt.toISOString()
  }

  if (value.Lt && value.Lt.toISOString) {
    query[FILTER_TYPE_LT] = value.Lt.toISOString()
  }

  return R.reject(R.isNil)(query)
}

export default {
  parseValue,
  valueToFilter,
}
